<template>
  <v-app-bar
    app
    :color="barColor"
    dark
  >
    <v-img
      class="mr-3"
      max-heght="32"
      max-width="32"
      src="/acri-logo.svg"
    />

    <router-link to="/" style="color: white; text-decoration: none;">
      <h1 class="font-weight-bold">
        ACRi HLS Challenge
      </h1>
    </router-link>

    <v-spacer></v-spacer>

    <v-btn
      to="/signin"
      text
      v-if="!user.authenticated"
    >
      <strong>ログイン</strong>
      <v-icon>mdi-login</v-icon>
    </v-btn>

    <div v-if="user.authenticated">
      <v-menu
        left
        offset-y
        open-on-hover
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
  
        <v-list>
          <v-list-item
            to="/new/challenge#detail"
          >
            <v-list-item-content>
              <v-list-item-title>チャレンジ新規作成</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu
        left
        offset-y
        open-on-hover
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-avatar 
              v-if="user.photoURL"
              size="36"
            >
              <img v-bind:src="user.photoURL" v-bind:alt="user.name">
            </v-avatar>
            <span
              v-if="!user.photoURL"
            >
              {{ user.name }}
            </span>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
  
        <v-list>
          <v-list-item
            to="/star-codes"
          >
            <v-list-item-icon>
              <v-icon>mdi-thumb-up</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>いいねしたコード</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/star-challenges"
          >
            <v-list-item-icon>
              <v-icon>mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>お気に入りチャレンジ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/my-codes"
          >
            <v-list-item-icon>
              <v-icon>mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>マイコード</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/my-challenges"
          >
            <v-list-item-icon>
              <v-icon>mdi-trophy</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>マイチャレンジ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/account"
          >
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>プロフィール</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
  
          <v-divider></v-divider>
  
          <v-list-item
            @click="signout"
          >
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>ログアウト</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

  </v-app-bar>
</template>

<script>
import firebase from "@/firebase/firebase.js"
import "firebase/auth";

export default {
  data: () => ({
    barColor: "grey darken-3",
  }),
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    signout() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/');
      });
    },
  },
};
</script>
